<template>
  <!-- start header -->
  <header id="top-bar" class="top-bar top-bar--style-1">
    <div class="top-bar__bg" style="background-color: #fff;;background-repeat: no-repeat;background-position: left bottom;"></div>

    <div class="container-fluid">
      <div class="row align-items-center justify-content-between no-gutters">

        <!-- <a class="top-bar__logo site-logo" href="index.html" style="background-color: #fff;
        border-right-width: 16px;
        max-width: 150px;
        height: auto;"> -->

        <router-link 
                      tag="a" 
                      to="/"
                      class="top-bar__logo site-logo"
                      style="background-color: transparent;
                      border-right-width: 16px;
                      max-width: 150px;
                      height: auto;">
                 <img class="img-fluid" src="img/site_logo.png" alt="demo" />     
        </router-link>
        
      <!-- </a> -->

      <a id="top-bar__navigation-toggler" class="top-bar__navigation-toggler top-bar__navigation-toggler--dark" href="javascript:void(0);" style=""><span></span></a>

      <div id="top-bar__inner" class="top-bar__inner">
        <div>
          <nav id="top-bar__navigation" class="top-bar__navigation navigation" role="navigation">
            <ul>

              <!-- <router-link 
                tag="a" 
                to="/productos_premium"
                active-class="active">Grupo ABS</router-link> -->

                <li>
                  <router-link
                  style="color:#333;" 
                  tag="a" 
                  to="/nosotros"
                  active-class="active">Grupo ABS</router-link>
                </li>

                <li class="has-submenu">
                  <a style="color:#333;" href="javascript:void(0);">Productos</a>

                  <ul class="submenu">
                    <li>
                      <router-link 
                      tag="a" 
                      to="/productos_premium"
                      active-class="active">Linea Premium</router-link>
                    </li>
                    <li><router-link 
                      tag="a" 
                      to="/productos"
                      active-class="active">Otros productos</router-link>
                    </li>
                  </ul>
                </li>

                <li>
                  <router-link 
                  style="color:#333;"
                  tag="a" 
                  to="/sucursales"
                  active-class="active">Sucursales</router-link>
                </li>

                <li>
                  <router-link 
                  style="color:#333;"
                  tag="a" 
                  to="/contacto"
                  active-class="active">Contacto</router-link>
                </li>

                <li style="position:relative" class="dropdown">
                  
                  <!-- <i @click="quote" class="fas fa-shopping-bag" style="color:#fff;font-size:22px;cursor:pointer;"></i>
                  <span v-if="true" class="badge"></span> -->

                  <button style="color:#333;" class="quote-btn">
                    <i @click="quote" class="fas fa-shopping-bag" style="color:#333;font-size:22px;cursor:pointer;"></i>
                    <span v-if="getQuotation.length >= 1" class="badge"></span>
                  </button>

                  <div v-if="showQuote" class="dropdown-content">
                    <div class="quote-items-list">
                      <ul style="text-align: left">
                        <li v-for="(item, index) in getQuotation" class="quote-item">{{ item.title }} 
                        <i
                          class="fas fa-times" 
                          style="float:right;cursor:pointer;"
                          @click="removeItem(index)"></i></li>
                      </ul>
                    </div>
                    <div>
                      <button 
                      style="width:100%;margin: 10px 0;padding: 8px 0;border-radius:4px;background-color: #43a553;color:#fff;font-size:16px;border: none;cursor:pointer"
                      @click="quotationModal">Solicitar cotización</button>
                    </div>
                    <hr>
                    <div style="padding-top: 10px;">         
                      
                      <button v-if="!auth" @click="showLogin" class="login-btn">
                        <i class="fas fa-user-circle"></i>Iniciar sesión
                      </button>

                      <button v-else @click="onLogout" class="login-btn">Salir</button>
                    </div>
                  </div>
                </li>
            
            </ul>
          </nav>
        </div>
      </div>

    </div>
  </div>

  <modal v-if="getShowModal" @close="showModal = false" />
  <QuotationModal v-if="showQuotationModal" @close="showQuotationModal = false" @click="" />
  <MobileQuotationModal v-if="mobileQuotationModal" @close="showModal = false"/>
</header>
<!-- end header -->	
</template>

<script>
import Modal from '@/components/LoginModal.vue'
import QuotationModal from '@/components/QuotationModal.vue'
import MobileQuotationModal from '@/components/MobileQuotationModal.vue'
import axios from 'axios'

export default {
  components: {
    Modal,
    QuotationModal,
    MobileQuotationModal
  },
  data () {
    return {
      showLoginModal: false,
      email: '',
      password: '',
      showProductModal: false,
      product: {},
      showModal: false,
      showQuote: false,
      showQuotationModal: false,
      quotation: {
        name: '',
        email: '',
        phone: ''
      },
      mobileQuotationModal: false
    }
  },
  created () {
    window.addEventListener('touchstart', this.closeModal)
    window.addEventListener('click', this.closeModal)
    window.addEventListener('touchstart', this.closeQuotationModal)
    window.addEventListener('click', this.closeQuotationModal)
  },
  destroyed () {
    window.addEventListener('touchstart', this.closeModal)
    window.addEventListener('click', this.closeModal)
    window.addEventListener('touchstart', this.closeQuotationModal)
    window.addEventListener('click', this.closeQuotationModal)
  },
  computed: {
    auth () {
      return this.$store.getters.isAuthenticated
    },
    getQuotation () {
      return this.$store.getters.quotationItems
    },
    getShowModal () {
      return this.$store.getters.showModal
    },
    getQuery () {
      return this.$store.getters.search
    }
  },
  methods: {
    showLogin () {
      // this.showModal = true
      // this.showQuote = false

      this.$store.commit('show')
    },
    closeModal () {
      var productModal = document.getElementById('productModal')

      if (event.target === productModal) {
        // this.showModal = false
        this.$store.commit('hide')
      }
    },
    login () {
      const formData = {
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('login', { email: formData.email, password: formData.password })
    },
    quotationModal () {
      this.showQuotationModal = true
      this.showQuote = false
    },
    closeQuotationModal () {
      var quotationModal = document.getElementById('quotationModal')

      if (event.target === quotationModal) {
        this.showQuotationModal = false
      }
    },
    quote () {
      if (this.showQuote === false) {
        this.showQuote = true
      } else {
        this.showQuote = false
      }
    },
    onLogout () {
      this.$store.dispatch('logout')
    },
    removeItem (index) {
      this.$store.commit('removeItemQuotation', index)
    },
    requestQuotation () {
      const items = this.getQuotation
      let quotation = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        products: "Biomax"
      }

      axios.post('/user/requestQuotation', quotation)
        .then(res => {
          this.quotationMessage = 'Su cotización ha sido enviada, pronto nos pondremos en contacto con usted.'
        })
        .catch(err => console.log(err))
    }
  }
};
</script>

<style type="text/css">
  .dropdown {
    position: relative;
  }

  .dropdown-content {
    /*display: none;*/
    position: absolute;
    background-color: #fff;
    min-width: 220px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    padding: 12px 16px;
    z-index: 99;
    margin-top: 10px;
    border-radius: 4px;
    right: -18px;
  }

  .quote-btn {
    background-color: transparent;
    border: none;
  }

  .quote-btn:focus {
    outline: 0;
  }

  .badge {
    background-color: #fa3e3e;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    color: white;
    padding: 1px 3px;
    font-size: 10px;
    position: absolute;
    top: 11px;
    right: -6px;
  }

  .quote-item {
    margin-left: 0 !important;
    display: block !important;
    font-weight: 500;
    padding: 10px 0 !important;
  }

  .login-btn {
    width: 100%;
    padding: 8px;
    font-size: 16px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
  }

  .login-btn:focus {
    outline: 0;
  }

  .login-btn i{
    margin-right: 8px;
  }
</style>
